import { cn } from '@cobliteam/ui/utils';
import L from 'leaflet';
import * as styles from './styles';

import flagIconUrl from '../icons/ic_flag.svg';

export const EndIcon = new L.DivIcon({
  html: `<div class="${styles.icon}"><img src="${flagIconUrl}" /></div>`,
  iconSize: [30, 30],
  iconAnchor: [15, 15],
});

export const EndIconComponent = () => {
  return (
    <div className={cn(styles.icon, 'cursor-auto')}>
      <img src={flagIconUrl} />
    </div>
  );
};
